import React, { useState, useEffect } from 'react';
import './AdminDashboard.css';

// Remove console.logs in production
  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }
  
const QuestionForm = ({ question, onSubmit, filter = 'Career Assessments' }) => {
  const [question_number, setQuestionNumber] = useState(question?.question_number?.toString() || '');
  const [question_text, setQuestionText] = useState(question?.question_text || '');
  const [example_info, setExampleInfo] = useState(question?.example_info || '');
  const [options, setOptions] = useState(
    question?.options?.length > 0
      ? [...question.options]
      : [{ optionText: '', score: 0 }]
  );
  const [answer_type, setAnswerType] = useState('multiple-choice');
  const [category, setCategory] = useState(question?.category || '');
  const [sub_category, setSubCategory] = useState(question?.sub_category || '');
  const [facet, setFacet] = useState(question?.facet || '');
  const [taxonomy, setTaxonomy] = useState(question?.taxonomy || []);
  const [newTaxonomy, setNewTaxonomy] = useState('');
  const [status, setStatus] = useState(filter);

  useEffect(() => {
    console.log('📋 QuestionForm received question:', question);
    if (question) {
      setQuestionNumber(question.question_number?.toString() || '');
      setQuestionText(question.question_text || '');
      setExampleInfo(question.example_info || '');
      setOptions(
        question.options?.length > 0
          ? [...question.options]
          : [{ optionText: '', score: 0 }]
      );
      setAnswerType('multiple-choice');
      setCategory(question.category || '');
      setSubCategory(question.sub_category || '');
      setFacet(question.facet || '');
      setTaxonomy(Array.isArray(question.taxonomy) ? question.taxonomy : []);
      setStatus(filter);
    } 
}, [question, filter]); // Add resetForm to dependency array

  const resetForm = () => {
    console.log('🔄 Resetting form');
    setQuestionNumber('');
    setQuestionText('');
    setExampleInfo('');
    setOptions([{ optionText: '', score: 0 }]);
    setAnswerType('multiple-choice');
    setCategory('');
    setSubCategory('');
    setFacet('');
    setTaxonomy([]);
    setNewTaxonomy('');
    setStatus(filter);
  };

  const handleOptionChange = (index, field, value) => {
    const updatedOptions = [...options];
    updatedOptions[index][field] = field === 'score' ? parseInt(value) || 0 : value;
    setOptions(updatedOptions);
  };

  const handleDeleteOption = (index) => {
    if (options.length > 1) {
      setOptions(options.filter((_, i) => i !== index));
    }
  };

  const handleAddTaxonomy = () => {
    if (newTaxonomy.trim() && !taxonomy.includes(newTaxonomy.trim())) {
      setTaxonomy([...taxonomy, newTaxonomy.trim()]);
      setNewTaxonomy('');
    }
  };

  const handleEditTaxonomy = (index, newValue) => {
    const updatedTaxonomy = [...taxonomy];
    updatedTaxonomy[index] = newValue.trim();
    setTaxonomy(updatedTaxonomy.filter((t) => t));
  };

  const handleDeleteTaxonomy = (index) => {
    setTaxonomy(taxonomy.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submittedQuestion = {
      question_id: question?.question_id || null,
      question_number,
      question_text,
      example_info,
      options: [...options],
      answer_type,
      category,
      sub_category,
      facet,
      status,
      taxonomy,
    };
    console.log('🚀 Submitting question:', submittedQuestion);
    onSubmit(submittedQuestion, question?.question_id ? 'update' : 'add');
    if (!question?.question_id) resetForm();
  };

  return (
    <div>
      <form className="form-group" onSubmit={handleSubmit}>
        <div className="form-group">
          <div className="question-row">
            <label>Question Number:</label>
            <input
              type="text"
              className="question-number"
              value={question_number}
              onChange={(e) => setQuestionNumber(e.target.value)}
              required
            />
          </div>
          <div className="question-text-container">
            <label>Question Text</label>
            <input
              type="text"
              className="question-text"
              value={question_text}
              onChange={(e) => setQuestionText(e.target.value)}
              required
            />
          </div>
          <div className="example-info-container">
            <label>Example Information</label>
            <textarea
              className="example-info"
              value={example_info}
              onChange={(e) => setExampleInfo(e.target.value)}
              placeholder="Enter example information for this question"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Category</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Sub-Category</label>
          <input
            type="text"
            value={sub_category}
            onChange={(e) => setSubCategory(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Facet</label>
          <input
            type="text"
            value={facet}
            onChange={(e) => setFacet(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Taxonomy</label>
          <div className="taxonomy-container">
            {taxonomy.map((tax, index) => (
              <div key={index} className="taxonomy-item">
                <input
                  type="text"
                  value={tax}
                  onChange={(e) => handleEditTaxonomy(index, e.target.value)}
                  placeholder="Enter taxonomy"
                />
                <button
                  type="button"
                  className="delete-taxonomy-btn"
                  onClick={() => handleDeleteTaxonomy(index)}
                >
                  🗑️
                </button>
              </div>
            ))}
            <div className="add-taxonomy">
              <input
                type="text"
                value={newTaxonomy}
                onChange={(e) => setNewTaxonomy(e.target.value)}
                placeholder="Add new taxonomy"
              />
              <button
                type="button"
                className="add-taxonomy-btn"
                onClick={handleAddTaxonomy}
                disabled={!newTaxonomy.trim()}
              >
                ➕ Add
              </button>
            </div>
          </div>
        </div>

           <div className="form-group">
          <label>Options</label>
          {options.map((option, index) => (
            <div key={index} className="option-score-container">
              <input
                type="text"
                className="option-text"
                placeholder="Option text"
                value={option.optionText}
                onChange={(e) => handleOptionChange(index, 'optionText', e.target.value)}
              />
              <label>
                Score:
                <input
                  type="number"
                  className="option-score"
                  placeholder="Score"
                  value={option.score}
                  onChange={(e) => handleOptionChange(index, 'score', e.target.value)}
                  min="0"
                />
              </label>
              <button
                type="button"
                className="delete-option-btn"
                onClick={() => handleDeleteOption(index)}
                disabled={options.length <= 1}
              >
                🗑️
              </button>
            </div>
          ))}
        </div>

      <div className="buttons-container">
          <button
            type="button"
            className="add-option-btn"
            onClick={() => setOptions([...options, { optionText: '', score: 0 }])}
          >
            ➕ Add Option
          </button>
          <button type="submit" className="submit-btn">
            {question?.question_id ? '✅ Update Question' : '➕ Add Question'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default QuestionForm;